import React, { useEffect, useState } from "react";
import {
  ControlsWrapper,
  ListItem,
  ListItemWrapper,
  StyledButton,
  StyledPopover,
  ActionButton,
  ActionButtonsWrapper,
} from "./styles";
import { CloseIcon } from "../../../images/icons/CloseIcon";
import { ExpandIcon } from "../../../images/icons/ExpandIcon";
import { UpArrowIcon } from "../../../images/icons/UpArrowIcon";
import { DownArrowIcon } from "../../../images/icons/DownArrowIcon";
import { useDispatch, useSelector } from "react-redux";
import { mapSelector } from "../store/selectors";
import { setCategories, setHelpType, setParentId } from "../store";

const serviceTypesItems = [
  { value: "repair", title: "Ремонт" },
  { value: "installation", title: "Установка" },
];



export const Controls = () => {
  const dispatch = useDispatch();

  const [isOpenServiceTypes, setIsOpenServiceTypes] = useState<any>(false);
  const [isOpenCategories, setIsOpenCategories] = useState<any>(false);

  const { parent_category_id, help_type, categories } =
    useSelector(mapSelector);

  useEffect(() => {
    const getCateg = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API}/${process.env.REACT_APP_API_VERSION}/categories?level=0&with_paginate=false&order_by=created_at`,
                {
                    method: "GET",
                    headers: {
                        accept: "application/json",
                        "Content-type": "application/json",
                        "x-request-id": "123",
                        "x-service-name": "123",
                    },
                },
            );
            const json = await response.json();
            dispatch(setCategories(json));

            // Устанавливаем все категории по умолчанию
            const array = json?.map((item: any) => item.id);
            dispatch(setParentId(array));
        }
        catch (e) {
            console.error(e);
        }

    };
    getCateg();
  }, [dispatch]);

  // Устанавливаем все типы услуг по умолчанию при загрузке
  useEffect(() => {
    const allServiceTypes = serviceTypesItems.map(item => item.value);
    dispatch(setHelpType(allServiceTypes));
  }, [dispatch]);

  const changeHelpType = (value: string) => {
    console.log('Changing help type:', value, 'Current:', help_type);
    if (help_type?.includes(value)) {
      const array = help_type?.filter((item) => item !== value);
      console.log('Removing, new array:', array);
      dispatch(setHelpType(array.length === 0 ? [] : array));
    } else {
      const array = help_type ? [...help_type, value] : [value];
      console.log('Adding, new array:', array);
      dispatch(setHelpType(array));
    }
  };

  const changeParentId = (value: string) => {
    if (parent_category_id?.includes(value)) {
      const array = parent_category_id?.filter((item) => item !== value);
      dispatch(setParentId(array.length === 0 ? [] : array));
    } else {
      const array = parent_category_id ? [...parent_category_id, value] : [value];
      dispatch(setParentId(array));
    }
  };

  const selectAllServiceTypes = (e: React.MouseEvent) => {
    e.stopPropagation();
    const allValues = serviceTypesItems.map(item => item.value);
    console.log('Selecting all service types:', allValues);
    dispatch(setHelpType(allValues));
  };

  const clearAllServiceTypes = (e: React.MouseEvent) => {
    e.stopPropagation();
    console.log('Clearing all service types');
    dispatch(setHelpType([]));
  };

  const selectAllCategories = (e: React.MouseEvent) => {
    e.stopPropagation();
    const allValues = categories?.map((item: any) => item.id) || [];
    dispatch(setParentId(allValues));
  };

  const clearAllCategories = (e: React.MouseEvent) => {
    e.stopPropagation();
    dispatch(setParentId([]));
  };

  return (
    <ControlsWrapper>
      <StyledButton
        onClick={(e) => setIsOpenServiceTypes(e.currentTarget)}
        endIcon={
          isOpenServiceTypes ? (
            <UpArrowIcon />
          ) : (
            <DownArrowIcon />
          )
        }
      >
        Тип услуги
      </StyledButton>
      <StyledPopover
        sx={{ pointerEvents: "none" }}
        slotProps={{ paper: { style: { pointerEvents: "auto" } } }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={Boolean(isOpenServiceTypes)}
        anchorEl={isOpenServiceTypes}
        onClose={() => setIsOpenServiceTypes(false)}
        onBlurCapture={(e) => {
          // Не закрываем попап, если клик был по кнопкам действий
          if (e.relatedTarget && 
              (e.relatedTarget.closest('[data-action-button]') || 
               e.currentTarget.contains(e.relatedTarget as Node))) {
            return;
          }
          setIsOpenServiceTypes(false);
        }}
      >
        <ListItemWrapper>
          {serviceTypesItems.map((item) => (
            <ListItem
              choised={Boolean(help_type?.includes(item?.value))}
              sx={{ cursor: "pointer" }}
              key={item.value}
              onClick={() => changeHelpType(item.value)}
            >
              {item.title}
            </ListItem>
          ))}
          <ActionButtonsWrapper>
            <ActionButton data-action-button onClick={(e) => selectAllServiceTypes(e)}>
              Выбрать все
            </ActionButton>
            <ActionButton data-action-button onClick={(e) => clearAllServiceTypes(e)}>
              Очистить все
            </ActionButton>
          </ActionButtonsWrapper>
        </ListItemWrapper>
      </StyledPopover>

      <StyledButton
        sx={{ marginLeft: "16px" }}
        onClick={(e) => {
          setIsOpenCategories(e.currentTarget);
        }}
        endIcon={
          isOpenCategories ? (
            <UpArrowIcon />
          ) : (
            <DownArrowIcon />
          )
        }
      >
        Категория
      </StyledButton>
      <StyledPopover
        sx={{ pointerEvents: "none" }}
        slotProps={{ paper: { style: { pointerEvents: "auto" } } }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={Boolean(isOpenCategories)}
        anchorEl={isOpenCategories}
        onClose={() => setIsOpenCategories(false)}
        onBlurCapture={(e) => {
          // Не закрываем попап, если клик был по кнопкам действий
          if (e.relatedTarget && 
              (e.relatedTarget.closest('[data-action-button]') || 
               e.currentTarget.contains(e.relatedTarget as Node))) {
            return;
          }
          setIsOpenCategories(false);
        }}
      >
        <ListItemWrapper>
          {categories.map((item) => (
            <ListItem
              choised={Boolean(parent_category_id?.includes(item?.id))}
              sx={{ cursor: "pointer" }}
              key={item.id}
              onClick={() => changeParentId(item?.id)}
            >
              {item.name}
            </ListItem>
          ))}
          <ActionButtonsWrapper>
            <ActionButton data-action-button onClick={(e) => selectAllCategories(e)}>
              Выбрать все
            </ActionButton>
            <ActionButton data-action-button onClick={(e) => clearAllCategories(e)}>
              Очистить все
            </ActionButton>
          </ActionButtonsWrapper>
        </ListItemWrapper>
      </StyledPopover>
    </ControlsWrapper>
  );
};
